import MapCardNew from "./MapCardNew";

export default MapCardNew;
